<div class="container">

    <app-header-dialog [iconName]="'print'">
    {{data.name}}
  </app-header-dialog>

  <div class='content'>
    <div class='report-criteria'>
      <div *ngFor="let item of array">
        <mat-checkbox [(ngModel)]="item.selected" (click)='markCheck(item)' color='primary'>
          {{item.name}}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button (click)="matDialogRef.close(['ok',data, array])">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>